export const PMS_TYPES_LIST = [
  {
    id: 1,
    title: 'Goods',
  },
  {
    id: 2,
    title: 'Services',
  },
];
